import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { heroSlides, SELO_30_URL } from '../mock';

const Hero = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroSlides.length), 6000);
    return () => clearInterval(t);
  }, []);

  const prev = () => setIdx((i) => (i - 1 + heroSlides.length) % heroSlides.length);
  const next = () => setIdx((i) => (i + 1) % heroSlides.length);

  return (
    <section id="home" className="relative w-full h-[calc(100vh-80px)] min-h-[560px] overflow-hidden mt-[80px]">
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${i === idx ? 'opacity-100' : 'opacity-0'}`}
        >
          <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
          {/* slight darkening at bottom for text readability, no extra gold overlay since the artwork already has it */}
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/40" />
        </div>
      ))}

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        {/* Official 30 ANOS Selo - black background dropped via mix-blend-mode: screen */}
        <div className="mb-10 flex items-center justify-center">
          <img
            src={SELO_30_URL}
            alt="30 anos - Técnica, confiança e impacto positivo"
            className="w-[260px] md:w-[340px] lg:w-[380px] h-auto select-none"
            style={{ mixBlendMode: 'screen' }}
            draggable={false}
          />
        </div>

        <h1
          className="text-white font-bold text-[22px] md:text-[34px] lg:text-[40px] tracking-[0.05em] max-w-4xl uppercase"
          style={{ fontFamily: "'Montserrat', sans-serif", textShadow: '0 2px 12px rgba(0,0,0,0.4)' }}
        >
          {heroSlides[idx].title}
        </h1>
      </div>

      {/* arrows */}
      <button
        onClick={prev}
        className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-20 text-white/80 hover:text-white transition-colors"
        aria-label="Anterior"
      >
        <ChevronLeft size={56} strokeWidth={1.5} />
      </button>
      <button
        onClick={next}
        className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-20 text-white/80 hover:text-white transition-colors"
        aria-label="Próximo"
      >
        <ChevronRight size={56} strokeWidth={1.5} />
      </button>

      {/* dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-3">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            className={`h-[3px] transition-all duration-300 ${i === idx ? 'w-10 bg-white' : 'w-6 bg-white/50'}`}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
